<template>
  <div>
    <template v-if="$route.name !== 'login'">
      <Header/>
    </template>
    <router-view/>
  </div>
</template>

<script>
import Header from './components/Header'

export default {
  name: 'App',
  components: {Header}
}
</script>

<style>

  html, body {
    /*font-family: 'Open Sans', serif;*/
    font-size: 100%;
    line-height: 1.5;
    min-height: 100vh;
    background-image: linear-gradient(to top, #bfcffb, #a0b0d7, #8293b4, #667692, #4b5a71);
  }

  select {
    width: 100%;
  }

  .select {
    width: 100%;
  }

  .help.counter {
    display: none;
  }


  .columns {
    width: 100%;
    margin-left: 0;
    background: #ECF0F3;
    -webkit-box-shadow: 0 1px 1px 0 rgba(0, 28, 36, .5);
    box-shadow: 0 1px 1px 0 rgba(0, 28, 36, .5);
  }

  .fas.fa-bars {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue